import React, { useState } from 'react';
import Input from '../../../components/ui/Input';

const ALL_TURKISH_CITIES = [
  { value: 'adana', label: 'Adana' },
  { value: 'adiyaman', label: 'Adıyaman' },
  { value: 'afyonkarahisar', label: 'Afyonkarahisar' },
  { value: 'agri', label: 'Ağrı' },
  { value: 'aksaray', label: 'Aksaray' },
  { value: 'amasya', label: 'Amasya' },
  { value: 'ankara', label: 'Ankara' },
  { value: 'antalya', label: 'Antalya' },
  { value: 'ardahan', label: 'Ardahan' },
  { value: 'artvin', label: 'Artvin' },
  { value: 'aydin', label: 'Aydın' },
  { value: 'balikesir', label: 'Balıkesir' },
  { value: 'bartin', label: 'Bartın' },
  { value: 'batman', label: 'Batman' },
  { value: 'bayburt', label: 'Bayburt' },
  { value: 'bilecik', label: 'Bilecik' },
  { value: 'bingol', label: 'Bingöl' },
  { value: 'bitlis', label: 'Bitlis' },
  { value: 'bolu', label: 'Bolu' },
  { value: 'burdur', label: 'Burdur' },
  { value: 'bursa', label: 'Bursa' },
  { value: 'canakkale', label: 'Çanakkale' },
  { value: 'cankiri', label: 'Çankırı' },
  { value: 'corum', label: 'Çorum' },
  { value: 'denizli', label: 'Denizli' },
  { value: 'diyarbakir', label: 'Diyarbakır' },
  { value: 'duzce', label: 'Düzce' },
  { value: 'edirne', label: 'Edirne' },
  { value: 'elazig', label: 'Elazığ' },
  { value: 'erzincan', label: 'Erzincan' },
  { value: 'erzurum', label: 'Erzurum' },
  { value: 'eskisehir', label: 'Eskişehir' },
  { value: 'gaziantep', label: 'Gaziantep' },
  { value: 'giresun', label: 'Giresun' },
  { value: 'gumushane', label: 'Gümüşhane' },
  { value: 'hakkari', label: 'Hakkari' },
  { value: 'hatay', label: 'Hatay' },
  { value: 'igdir', label: 'Iğdır' },
  { value: 'isparta', label: 'Isparta' },
  { value: 'istanbul', label: 'İstanbul' },
  { value: 'izmir', label: 'İzmir' },
  { value: 'kahramanmaras', label: 'Kahramanmaraş' },
  { value: 'karabuk', label: 'Karabük' },
  { value: 'karaman', label: 'Karaman' },
  { value: 'kars', label: 'Kars' },
  { value: 'kastamonu', label: 'Kastamonu' },
  { value: 'kayseri', label: 'Kayseri' },
  { value: 'kilis', label: 'Kilis' },
  { value: 'kirikkale', label: 'Kırıkkale' },
  { value: 'kirklareli', label: 'Kırklareli' },
  { value: 'kirsehir', label: 'Kırşehir' },
  { value: 'kocaeli', label: 'Kocaeli' },
  { value: 'konya', label: 'Konya' },
  { value: 'kutahya', label: 'Kütahya' },
  { value: 'malatya', label: 'Malatya' },
  { value: 'manisa', label: 'Manisa' },
  { value: 'mardin', label: 'Mardin' },
  { value: 'mersin', label: 'Mersin' },
  { value: 'mugla', label: 'Muğla' },
  { value: 'mus', label: 'Muş' },
  { value: 'nevsehir', label: 'Nevşehir' },
  { value: 'nigde', label: 'Niğde' },
  { value: 'ordu', label: 'Ordu' },
  { value: 'osmaniye', label: 'Osmaniye' },
  { value: 'rize', label: 'Rize' },
  { value: 'sakarya', label: 'Sakarya' },
  { value: 'samsun', label: 'Samsun' },
  { value: 'sanliurfa', label: 'Şanlıurfa' },
  { value: 'siirt', label: 'Siirt' },
  { value: 'sinop', label: 'Sinop' },
  { value: 'sirnak', label: 'Şırnak' },
  { value: 'sivas', label: 'Sivas' },
  { value: 'tekirdag', label: 'Tekirdağ' },
  { value: 'tokat', label: 'Tokat' },
  { value: 'trabzon', label: 'Trabzon' },
  { value: 'tunceli', label: 'Tunceli' },
  { value: 'usak', label: 'Uşak' },
  { value: 'van', label: 'Van' },
  { value: 'yalova', label: 'Yalova' },
  { value: 'yozgat', label: 'Yozgat' },
  { value: 'zonguldak', label: 'Zonguldak' },
];

const BasicInfoSection = ({ formData, errors, onChange }) => {

  // Local state to track what the user is currently typing
  const [dateDisplay, setDateDisplay] = useState(() => {
    if (!formData?.date) return '';
    const parts = formData?.date?.split('-');
    if (parts?.length === 3) {
      const [year, month, day] = parts;
      return `${day}.${month}.${year}`;
    }
    return formData?.date || '';
  });

  const handleDateInput = (e) => {
    let raw = e?.target?.value?.replace(/[^0-9]/g, '');
    if (raw?.length > 8) raw = raw?.slice(0, 8);

    let formatted = raw;
    if (raw?.length > 4) {
      formatted = raw?.slice(0, 2) + '.' + raw?.slice(2, 4) + '.' + raw?.slice(4);
    } else if (raw?.length > 2) {
      formatted = raw?.slice(0, 2) + '.' + raw?.slice(2);
    }

    setDateDisplay(formatted);

    // Only update parent with stored format when date is complete
    const parts = formatted?.split('.');
    if (parts?.length === 3 && parts?.[2]?.length === 4) {
      const [day, month, year] = parts;
      const stored = `${year}-${month?.padStart(2, '0')}-${day?.padStart(2, '0')}`;
      onChange({ target: { name: 'date', value: stored } });
    } else {
      onChange({ target: { name: 'date', value: formatted } });
    }
  };

  return (
    <div className="bg-card rounded-lg md:rounded-xl lg:rounded-2xl p-4 md:p-6 lg:p-8 shadow-organic">
      <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground mb-4 md:mb-5 lg:mb-6">
        Temel Bilgiler
      </h2>
      <div className="space-y-4 md:space-y-5 lg:space-y-6">
        <Input
          label="Etkinlik Başlığı"
          type="text"
          name="title"
          placeholder="Örn: Boğaz'da Gün Batımı SUP Turu"
          value={formData?.title}
          onChange={onChange}
          error={errors?.title}
          required
          description="Etkinliğiniz için çekici ve açıklayıcı bir başlık seçin"
        />
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 lg:gap-6">
          <div className="space-y-2">
            <label htmlFor="eventType" className="block text-sm font-medium text-foreground">
              Etkinlik Türü <span className="text-red-500">*</span>
            </label>
            <select
              id="eventType"
              name="eventType"
              value={formData?.eventType}
              onChange={onChange}
              className={`w-full px-4 py-2.5 bg-background border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary transition-all ${
                errors?.eventType ? 'border-red-500' : 'border-border hover:border-primary'
              }`}
              required
            >
              <option value="kitesurfing">Kitesurfing</option>
              <option value="windsurfing">Windsurfing</option>
              <option value="sup">Stand Up Paddle (SUP)</option>
              <option value="surfing">Surfing</option>
              <option value="wakeboarding">Wakeboarding</option>
              <option value="kayaking">Kayaking</option>
            </select>
            {errors?.eventType && (
              <p className="text-sm text-red-500 mt-1">{errors?.eventType}</p>
            )}
          </div>

          <div className="space-y-2">
            <label htmlFor="city" className="block text-sm font-medium text-foreground">
              Şehir <span className="text-red-500">*</span>
            </label>
            <select
              id="city"
              name="city"
              value={formData?.city}
              onChange={onChange}
              className="w-full px-4 py-2.5 bg-background border border-border hover:border-primary rounded-lg focus:outline-none focus:ring-2 focus:ring-primary transition-all"
              required
            >
              <option value="">Şehir seçin</option>
              {ALL_TURKISH_CITIES?.map((city) => (
                <option key={city?.value} value={city?.value}>{city?.label}</option>
              ))}
            </select>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 lg:gap-6">
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-foreground">
              Etkinlik Tarihi <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="GG.AA.YYYY"
              value={dateDisplay}
              onChange={handleDateInput}
              maxLength={10}
              className={`w-full border rounded-lg px-4 py-2.5 text-sm text-foreground bg-background focus:outline-none focus:ring-2 focus:ring-primary transition-all ${
                errors?.date ? 'border-red-500' : 'border-border hover:border-primary'
              }`}
            />
            {errors?.date && (
              <p className="text-sm text-red-500 mt-1">{errors?.date}</p>
            )}
          </div>
          
          <Input
            label="Başlangıç Saati"
            type="time"
            name="time"
            value={formData?.time}
            onChange={onChange}
            error={errors?.time}
            required
          />
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 lg:gap-6">
          <Input
            label="Süre (Saat)"
            type="number"
            name="duration"
            placeholder="2"
            value={formData?.duration}
            onChange={onChange}
            error={errors?.duration}
            required
            min="0.5"
            step="0.5"
          />
          
          <Input
            label="Zorluk Seviyesi"
            type="text"
            name="difficulty"
            value={formData?.difficulty}
            onChange={onChange}
            error={errors?.difficulty}
            required
            list="difficulty-options"
          />
          <datalist id="difficulty-options">
            <option value="Başlangıç Seviyesi" />
            <option value="Orta Seviye" />
            <option value="İleri Seviye" />
            <option value="Tüm Seviyeler" />
          </datalist>
        </div>
      </div>
    </div>
  );
};

export default BasicInfoSection;